document.addEventListener('click',function(e){const b=e.target.closest('[data-menu-toggle]');if(b){const n=document.getElementById(b.getAttribute('aria-controls'));if(n){const open=b.getAttribute('aria-expanded')!=='true';b.setAttribute('aria-expanded',String(open));n.classList.toggle('open',open)}}if(e.target.closest('.primaryNav a')){document.querySelectorAll('[data-menu-toggle]').forEach(b=>b.setAttribute('aria-expanded','false'));document.querySelectorAll('.primaryNav').forEach(n=>n.classList.remove('open'))}});function initVariants(){document.querySelectorAll('[data-variant-select]').forEach(s=>{if(s.dataset.bound)return;s.dataset.bound='true';const update=()=>{const o=s.options[s.selectedIndex];const f=s.closest('form');const b=f.querySelector('[data-add]');b.disabled=o.dataset.available!=='true';b.textContent=b.disabled?'Uitverkocht':'Toevoegen aan mandje';const p=document.getElementById(s.dataset.priceTarget);if(p)p.textContent=o.dataset.price;const u=new URL(window.location.href);u.searchParams.set('variant',s.value);history.replaceState({},'',u)};s.addEventListener('change',update)})}initVariants();document.addEventListener('shopify:section:load',initVariants);

function updateHeaderTransparency() {
  document.querySelectorAll('.topbar').forEach(header => {
    header.classList.toggle('is-scrolled', window.scrollY > 50);
  });
}

window.addEventListener('scroll', updateHeaderTransparency, {
  passive: true
});

document.addEventListener(
  'shopify:section:load',
  updateHeaderTransparency
);

updateHeaderTransparency();

